if (typeof ModalDialog !== 'undefined' && !customElements.get('feature-image-modal')) {
  customElements.define('feature-image-modal', class FeatureImageModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[data-feature-image-modal-content]');
      // 先読み（プリフェッチ）したページの内容をURLごとにキャッシュする
      this.contentCache = new Map();
    }

    hide(preventFocus = false) {
      if (this.modalContent) this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    setErrorContent() {
      this.modalContent.innerHTML = `<p class="feature-image-modal__error">${this.getAttribute('data-error-message') || ''}</p>`;
    }

    // このモーダル要素の内側だけを対象にスクロール位置を最上部にリセットする（他ページ・モーダル外への干渉を防止）
    resetScroll() {
      const modal = this;
      const scrollContainer = modal.querySelector('.feature-image-modal__scroll');
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
        // モーダル内部の要素のみを対象にスクロールをリセット（外部への干渉を防止）
        const innerElements = scrollContainer.querySelectorAll('*');
        innerElements.forEach((el) => {
          if (el.scrollTop > 0) el.scrollTop = 0;
        });
      }
    }

    resolveUrl(url) {
      if (!url) return null;
      let resolvedUrl;
      try {
        resolvedUrl = new URL(url, window.location.origin);
      } catch (error) {
        return null;
      }
      if (resolvedUrl.origin !== window.location.origin) return null;
      return resolvedUrl.href;
    }

    // ボタンが画面内に表示されたタイミング等で、あらかじめ内容を取得しておく
    prefetch(url) {
      const resolvedUrl = this.resolveUrl(url);
      if (!resolvedUrl || this.contentCache.has(resolvedUrl)) return;

      const request = fetch(resolvedUrl)
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const main = responseHTML.querySelector('#MainContent');
          return main ? main.innerHTML : responseHTML.body.innerHTML;
        })
        .catch(() => null);

      this.contentCache.set(resolvedUrl, request);
    }

    showFromUrl(url, opener) {
      if (!url || !this.modalContent) return;

      const resolvedUrl = this.resolveUrl(url);
      if (!resolvedUrl) {
        this.setErrorContent();
        super.show(opener);
        return;
      }

      // 未取得の場合はここで取得を開始する（先読みが間に合わなかった場合の保険）
      this.prefetch(url);

      this.modalContent.innerHTML = '';

      this.contentCache.get(resolvedUrl)
        .then((html) => {
          if (html === null) {
            this.setErrorContent();
            return;
          }
          this.modalContent.innerHTML = html;
          // コンテンツを差し替えた直後に、スクロール位置を最上部にリセットする
          this.resetScroll();
        })
        .catch(() => {
          this.setErrorContent();
          this.resetScroll();
        })
        .finally(() => {
          super.show(opener);
          // オープン時にも改めてリセットし、表示アニメーション等によるずれを防止する
          this.resetScroll();
        });
    }
  });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-feature-image-modal-target]');
  if (!trigger) return;

  const modal = document.querySelector(trigger.getAttribute('data-feature-image-modal-target'));
  if (!modal) return;

  event.preventDefault();
  modal.showFromUrl(trigger.getAttribute('href'), trigger);
});

// MOREボタン等が画面内に入ったタイミングで、遷移先ページを先読み（プリフェッチ）しておく
if ('IntersectionObserver' in window) {
  const prefetchObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const trigger = entry.target;
      observer.unobserve(trigger);

      const modal = document.querySelector(trigger.getAttribute('data-feature-image-modal-target'));
      if (modal && typeof modal.prefetch === 'function') {
        modal.prefetch(trigger.getAttribute('href'));
      }
    });
  }, { rootMargin: '200px' });

  document.querySelectorAll('[data-feature-image-modal-target]').forEach((trigger) => {
    prefetchObserver.observe(trigger);
  });
}
